module.exports = __webpack_public_path__ + "static/media/bg-image-23.269c71f6.jpg";